import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';

import { IBetslip } from '../../../../../bet-generation/models';
import { EditBetPicksResultedState } from '../../../../../edit-bet/services/edit-bet-utils';
import { IncorrectOptionsCountPreCheckError } from '../../../../errors/pre-check/incorrect-options-count-pre-check-error';
import { ErrorDetailsSpecifier } from '../../../../errors/pre-check/pre-check-error';
import { EditBetTypeValidationContext } from '../../../../models/models';
import { IEditBetTypeBetslipValidator } from '../validators';

@Injectable()
export class EditBetIncorrectOptionsCountValidator implements IEditBetTypeBetslipValidator<IncorrectOptionsCountPreCheckError> {
    constructor(private config: BetslipConfig) {}

    validate(_: IBetslip, context: EditBetTypeValidationContext): IncorrectOptionsCountPreCheckError[] {
        const resultedState = context.editBetContext.getResultStatus();
        // eslint-disable-next-line no-bitwise
        if (!(resultedState & EditBetPicksResultedState.Open)) {
            return [];
        }

        const selectedPicks = context.editBetContext.activePicksCount;

        if (selectedPicks < 1) {
            return [new IncorrectOptionsCountPreCheckError(1, selectedPicks, ErrorDetailsSpecifier.SelectMinSingleBets)];
        }

        if (selectedPicks > this.config.maxBetslipBets) {
            return [new IncorrectOptionsCountPreCheckError(this.config.maxBetslipBets, selectedPicks, ErrorDetailsSpecifier.PicksMaximum)];
        }

        return [];
    }
}
